import { Pipe, PipeTransform } from '@angular/core';
import { SelectDatetimeComponent } from '../../features/booking/pages/select-datetime/select-datetime.component';

@Pipe({
    name: 'nextHour',
    pure: false
})
export class NextHourPipe implements PipeTransform {

    constructor(private select: SelectDatetimeComponent) { }

    transform(objects: any[]): any[] {
        if (objects) {
            return objects.filter(object => {
                if (object.totalForReservation !== object.reservated) {
                    return object.hour;
                }
            });
        }
    }
}
